<template>
    <div class="row mt-0">
        <div class="col-6 pt-0">
            <h3>Audience Details</h3>
            <i class="fas fa-cog"></i> <span style="padding-left: 5px;"> General</span>
            <ul>
                <li>Activation Name: {{ $store.getters['ActivateAudienceStore/getDescription'] }}</li>
                <li>Query Relation: <strong> {{ activation.query }} </strong></li>
                <li v-if="!$store.getters['ActivateAudienceStore/getLimitByFrequencyStatus'] && !$store.getters['ActivateAudienceStore/getLimitByDistanceStatus']">Total Devices: {{ new Intl.NumberFormat().format($store.getters['ActivateAudienceStore/getAudience']) }}</li>
                <li v-if="$store.getters['ActivateAudienceStore/getLimitByFrequencyStatus'] || $store.getters['ActivateAudienceStore/getLimitByDistanceStatus']">Limit: {{ new Intl.NumberFormat().format($store.getters['ActivateAudienceStore/getLimitsTotal']) }}</li>
            </ul>
            <div v-for="(activationItem, index) in activation.dataset">
                <div v-if="index === 1" class="area-divider"> {{ activation.query }}</div>
                <div class="area-item">
                    <i class="fas fa-chart-area"></i> <span style="padding-left: 5px;"> Analysis</span>
                    <ul>
                        <li>Analysis Type: {{ activationItem.analysistype }}</li>
                        <li v-if="!activation.isOldDates && !['Cohorts'].includes(activationItem.analysistype)">Start Date: {{ activationItem.startDate }}</li>
                        <li v-if="!activation.isOldDates && !['Cohorts'].includes(activationItem.analysistype)">End Date: {{ activationItem.endDate }}</li>

                        <li v-if="activationItem.signalproviders.length"><span v-html="showHideValue('signal-providers', index)" class="toggle-button" @click="toggleShow('signal-providers', index)"></span> {{ activationItem.signalproviders.length }} Signal Providers </li>
                        <ul v-if="activationItem.signalproviders.length" :class="{'hide-toggle' : !showedData.includes('signal-providers_' + index)}">
                            <li v-for="provider in activationItem.signalproviders">{{ provider }}</li>
                        </ul>

                        <li v-if="activationItem.analysistype === 'Anonymized' && activationItem.countries.length"><span v-html="showHideValue('countries', index)" class="toggle-button" @click="toggleShow('countries', index)"></span> {{ activationItem.countries.length }} Countries </li>
                        <ul v-if="activationItem.analysistype === 'Anonymized' && activationItem.countries.length" :class="{'hide-toggle' : !showedData.includes('countries_' + index)}">
                            <li v-for="country in activationItem.countries">{{ country }}</li>
                        </ul>

                        <li v-if="activationItem.analysistype === 'Cohorts'">Name: {{ activationItem.cohort_name }}</li>

                        <li v-if="activationItem.categories.length"><span v-html="showHideValue('categories', index)" class="toggle-button" @click="toggleShow('categories', index)"></span> {{ activationItem.categories.length }} Categories </li>
                        <ul v-if="activationItem.categories.length" :class="{'hide-toggle' : !showedData.includes('categories_' + index)}">
                            <li v-for="category in activationItem.categories">{{ category }}</li>
                        </ul>

                        <li v-if="activationItem.analysisdata.length"><span v-html="showHideValue('data', index)" class="toggle-button" @click="toggleShow('data', index)"></span> {{ activationItem.analysisdata.length }} Data </li>
                        <ul v-if="activationItem.analysisdata.length" :class="{'hide-toggle' : !showedData.includes('data_' + index)}">
                            <li v-for="data in activationItem.analysisdata">{{ data }}</li>
                        </ul>

                        <li v-if="activationItem.analysistype === 'POI' && activationItem.locations.length"><span v-html="showHideValue('locations', index)" class="toggle-button" @click="toggleShow('locations', index)"></span> {{ activationItem.locations.length }} Locations </li>
                        <ul v-if="activationItem.analysistype === 'POI' && activationItem.locations.length" :class="{'hide-toggle' : !showedData.includes('locations_' + index)}">
                            <li v-for="location in activationItem.locations">{{ location }}</li>
                        </ul>
                    </ul>
                    <div v-if="activationItem.analysistype === 'POI'">
                        <i class="fas fa-location-arrow"></i> <span style="padding-left: 5px;"> Location </span>
                        <ul>
                            <li v-if="activationItem.countries.length"><span v-html="showHideValue('countries', index)" class="toggle-button" @click="toggleShow('countries', index)"></span> {{ activationItem.countries.length }} Countries </li>
                            <ul v-if="activationItem.countries.length" :class="{'hide-toggle' : !showedData.includes('countries_' + index)}">
                                <li v-for="country in activationItem.countries">{{ country }}</li>
                            </ul>

                            <li v-if="activationItem.states.length"><span v-html="showHideValue('states', index)" class="toggle-button" @click="toggleShow('states', index)"></span> {{ activationItem.states.length }} States </li>
                            <ul v-if="activationItem.states.length" :class="{'hide-toggle' : !showedData.includes('states_' + index)}">
                                <li v-for="state in activationItem.states">{{ state }}</li>
                            </ul>

                            <li v-if="activationItem.dmas.length"><span v-html="showHideValue('dmas', index)" class="toggle-button" @click="toggleShow('dmas', index)"></span> {{ activationItem.dmas.length }} DMAs </li>
                            <ul v-if="activationItem.dmas.length" :class="{'hide-toggle' : !showedData.includes('dmas_' + index)}">
                                <li v-for="dma in activationItem.dmas">{{ dma }}</li>
                            </ul>

                            <li v-if="activationItem.cities.length"><span v-html="showHideValue('cities', index)" class="toggle-button" @click="toggleShow('cities', index)"></span> {{ activationItem.cities.length }} Cities </li>
                            <ul v-if="activationItem.cities.length" :class="{'hide-toggle' : !showedData.includes('cities_' + index)}">
                                <li v-for="city in activationItem.cities">{{ city }}</li>
                            </ul>

                            <li v-if="activationItem.zipcodes.length"><span v-html="showHideValue('zipcodes', index)" class="toggle-button" @click="toggleShow('zipcodes', index)"></span> {{ activationItem.zipcodes.length }} Zip Codes </li>
                            <ul v-if="activationItem.zipcodes.length" :class="{'hide-toggle' : !showedData.includes('zipcodes_' + index)}">
                                <li v-for="zipcode in activationItem.zipcodes">{{ zipcode }}</li>
                            </ul>
                        </ul>
                    </div>
                    
                    <div v-if="['Anonymized'].includes(activationItem.analysistype)">
                        <i class="fas fa-filter"></i> <span style="padding-left: 5px;"> Selected Fields </span>

                        <ul>
                            <li v-if="['Anonymized'].includes(activationItem.analysistype) && activationItem.selectedFields && activationItem.selectedFields.geoLocation">
                                <span v-html="showHideValue('geo', index)" class="toggle-button" @click="toggleShow('geo', index)"></span>
                                {{ activationItem.selectedFields.geoLocation.length }} Geo Location
                            </li>
                            <ul v-if="['Anonymized'].includes(activationItem.analysistype) && activationItem.selectedFields && activationItem.selectedFields.geoLocation" :class="{'hide-toggle' : !showedData.includes('geo_' + index)}">
                                <li v-for="item in activationItem.selectedFields.geoLocation"> {{ item }} </li>
                            </ul>

                            <li v-if="['Anonymized'].includes(activationItem.analysistype) && activationItem.selectedFields && activationItem.selectedFields.Advertising">
                                <span v-html="showHideValue('advertising', index)" class="toggle-button" @click="toggleShow('advertising', index)"></span>
                                {{ activationItem.selectedFields.Advertising.length }} Advertising
                            </li>
                            <ul v-if="['Anonymized'].includes(activationItem.analysistype) && activationItem.selectedFields && activationItem.selectedFields.Advertising" :class="{'hide-toggle' : !showedData.includes('advertising_' + index)}">
                                <li v-for="item in activationItem.selectedFields.Advertising"> {{ item }} </li>
                            </ul>

                            <li v-if="['Anonymized'].includes(activationItem.analysistype) && activationItem.selectedFields && activationItem.selectedFields.userDetails">
                                <span v-html="showHideValue('user_details', index)" class="toggle-button" @click="toggleShow('user_details', index)"></span>
                                {{ activationItem.selectedFields.userDetails.length }} User Details
                            </li>
                            <ul v-if="['Anonymized'].includes(activationItem.analysistype) && activationItem.selectedFields && activationItem.selectedFields.userDetails" :class="{'hide-toggle' : !showedData.includes('user_details_' + index)}">
                                <li v-for="item in activationItem.selectedFields.userDetails"> {{ item }} </li>
                            </ul>

                            <li v-if="['Anonymized'].includes(activationItem.analysistype) && activationItem.selectedFields && activationItem.selectedFields.ipDetails">
                                <span v-html="showHideValue('ip_details', index)" class="toggle-button" @click="toggleShow('ip_details', index)"></span>
                                {{ activationItem.selectedFields.ipDetails.length }} IP Details
                            </li>
                            <ul v-if="['Anonymized'].includes(activationItem.analysistype) && activationItem.selectedFields && activationItem.selectedFields.ipDetails" :class="{'hide-toggle' : !showedData.includes('ip_details_' + index)}">
                                <li v-for="item in activationItem.selectedFields.ipDetails"> {{ item }} </li>
                            </ul>

                            <li v-if="['Anonymized'].includes(activationItem.analysistype) && activationItem.selectedFields && activationItem.selectedFields.privacy">
                                <span v-html="showHideValue('privacy', index)" class="toggle-button" @click="toggleShow('privacy', index)"></span>
                                {{ activationItem.selectedFields.privacy.length }} Privacy
                            </li>
                            <ul v-if="['Anonymized'].includes(activationItem.analysistype) && activationItem.selectedFields && activationItem.selectedFields.privacy" :class="{'hide-toggle' : !showedData.includes('privacy_' + index)}">
                                <li v-for="item in activationItem.selectedFields.privacy"> {{ item }} </li>
                            </ul>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-6 pt-0">
            <h3>Data Delivery Details</h3>
            <i class="fas fa-cog"></i> <span style="padding-left: 5px;"> General Data</span>
            <ul>
                <li>
                    <span class="font-weight-bold">Pricing Model:</span> {{ pricing_model }}
                </li>
            </ul>

            <span v-if="is_datastream_selected">
                <i class="fas fa-stream"></i> <span style="padding-left: 5px;"> DataStreams Delivery</span>
                <ul v-if="datastream.status" v-for="datastream in datastreams_delivery">
                    <li>
                        <span class="font-weight-bold">Name:</span> {{ datastream.name }}
                    </li>
                    <ul>
                        <li v-if="datastream.visualizing_status">
                            <span class="font-weight-bold">Visualizing:</span> Selected
                        </li>
                        <li>
                            <span class="font-weight-bold">Compression Type:</span> {{ datastream.compression }}
                        </li>
                        <li v-for="(input, index) in datastream.inputs" v-if="partner.inputs[index].type !== 'file'">
                            <span class="font-weight-bold">{{ partner.inputs[index].name }}:</span> {{ input }}
                        </li>
                    </ul>
                </ul>
            </span>
        </div>
    </div>
</template>

<script>

export default {
    name: "ActivationSummary",
    props: [],
    data: () => ({
        showedData: [],
    }),
    methods: {
        //
    },
    created() {
        //
    },
    mounted() {
        //
    },
    computed: {
        pricing_model: function () {
            let selected_pricing_model = this.$store.getters['ActivateAudienceStore/getPricingModelsData'].filter(pricing_model => pricing_model.id === this.$store.getters['ActivateAudienceStore/getPricingModel'])

            return selected_pricing_model[0].label + ' - ' + selected_pricing_model[0].price
        },
        is_datastream_selected() {
            let is_selected = false
            this.$store.getters['ActivateAudienceStore/getDataStreamsDeliveryData'].forEach(datastream => {
                if (datastream.status) {
                    is_selected = true
                }
            })

            return is_selected
        },
        partner: function () {
            return this.$store.getters['ActivateAudienceStore/getActivationPartner']
        },
        activation: function () {
            return this.$store.getters['ActivateAudienceStore/getActivation']
        },
        datastreams_delivery: function () {
            return this.$store.getters['ActivateAudienceStore/getDataStreamsDeliveryData']
        },
        audience_delivery: function () {
            return this.$store.getters['ActivateAudienceStore/getAudienceDeliveryData']
        }
    },
    watch: {
        //
    }
}
</script>

<style scoped>

</style>